/**
 * Master Tax Responsibility Disclaimer
 * 
 * Per AMENDMENTS Q12 / BR-T-09, this disclaimer MUST appear on 3 surfaces:
 * 1. Settings > Tax & Rates page header
 * 2. Quote detail — tax-line area
 * 3. Invoice export interstitial
 * 
 * DO NOT modify this text without operator approval.
 */

export const MASTER_TAX_DISCLAIMER = 
  'You are responsible for any final tax revenue reported to state and federal authorities. BIDIT provides informational guidance only.';

export const TAX_RATE_HELPER_DISCLAIMER = 
  "Suggested rate based on your state's base sales tax. Local jurisdiction may add additional tax. You are responsible for final compliance — verify with your state revenue office or tax accountant before invoicing.";

export default MASTER_TAX_DISCLAIMER;
